import { Trans, t } from "@lingui/macro";
import { StaticImageData } from "next/image";
import React from "react";
import styled from "styled-components";
import { Stack } from "~/guidelines/Flex";
import { heading2, heading5 } from "~/guidelines/Typography";
import ArlesApres from "../_assets/our-projects/arles-apres.png";
import ArlesAvant from "../_assets/our-projects/arles-avant.png";
import OrleansApres from "../_assets/our-projects/orlean-apres.png";
import OrleansAvant from "../_assets/our-projects/orlean-avant.png";
import TerrasseApres from "../_assets/our-projects/terrasse-apres.png";
import TerrasseAvant from "../_assets/our-projects/terrasse-avant.png";
import ToursApres from "../_assets/our-projects/tours-apres.png";
import ToursAvant from "../_assets/our-projects/tours-avant.png";
import OurProjectsDesktop from "./OurProjectsDesktop";
import OurProjectsMobile from "./OurProjectsMobile";

const Container = styled(Stack)`
  align-items: center;
  margin: ${({ theme }) => theme.spacing(10)} auto;
  width: 100%;
  max-width: 95vw;

  @media (max-width: 900px) {
    margin: ${({ theme }) => theme.spacing(4)} auto;
  }
`;

const PreTitle = styled.h5`
  ${heading5}
  margin-bottom: 0px;
  text-align: center;
`;

const Title = styled.h2`
  ${heading2}
  margin-bottom: ${({ theme }) => theme.spacing(8)};
  text-align: center;
`;

const DesktopOnly = styled.div`
  display: block;
  width: 100%;

  @media (max-width: ${({ theme }) => theme.breakpoints.xl}) {
    display: none;
  }
`;

const MobileOnly = styled.div`
  display: none;
  width: 100%;

  @media (max-width: ${({ theme }) => theme.breakpoints.xl}) {
    display: block;
  }
`;

export interface ProjectData {
  id: string;
  label: string;
  beforeSrc: StaticImageData | string;
  afterSrc: StaticImageData | string;
}

const OurProjects = () => {
  const projectsData: ProjectData[] = [
    {
      id: "terrace-tours",
      label: t`Terrace in Tours`,
      beforeSrc: TerrasseAvant,
      afterSrc: TerrasseApres,
    },
    {
      id: "living-room-orleans",
      label: t`Living Room in Orleans`,
      beforeSrc: OrleansAvant,
      afterSrc: OrleansApres,
    },
    {
      id: "family-room-tours",
      label: t`Family Room in Tours`,
      beforeSrc: ToursAvant,
      afterSrc: ToursApres,
    },
    {
      id: "double-bedroom-arles",
      label: t`Double Bedroom in Arles`,
      beforeSrc: ArlesAvant,
      afterSrc: ArlesApres,
    },
  ];

  return (
    <Container>
      <PreTitle>
        <Trans>Ours</Trans>
      </PreTitle>

      <Title>
        <Trans>Projects</Trans>
      </Title>

      <DesktopOnly>
        <OurProjectsDesktop projects={projectsData} />
      </DesktopOnly>

      <MobileOnly>
        <OurProjectsMobile projects={projectsData} />
      </MobileOnly>
    </Container>
  );
};

export default OurProjects;
